import React from "react";

/* Placeholder module for tabs whose owning Build Pack hasn't landed yet.

   The backend manifest gives us:
     { id, label, owning_bp, status: "coming_soon", enabled: false }
   — this component renders a friendly "Preview" panel referencing
   the owning BP. Never hits any endpoint.
*/
export default function ComingSoonTab({ tab }) {
  return (
    <div
      data-testid={`tab-panel-${tab.id}`}
      className="rounded-xl border border-slate-200 bg-white p-10 text-center"
    >
      <div className="mx-auto max-w-md space-y-3">
        <span className="inline-flex items-center gap-1.5 text-[10px] uppercase tracking-widest font-black px-2.5 py-1 rounded-full bg-amber-500/10 text-amber-700 ring-1 ring-amber-500/30">
          Preview
        </span>
        <h3 className="text-lg font-semibold text-slate-900">{tab.label}</h3>
        <p className="text-sm text-slate-600">
          Ships with{" "}
          <span className="font-mono px-1.5 py-0.5 rounded bg-slate-100 text-amber-700">
            {tab.owning_bp}
          </span>
          .
        </p>
        {tab.description ? (
          <p className="text-xs text-slate-500 leading-relaxed">{tab.description}</p>
        ) : null}
      </div>
    </div>
  );
}
